export default "__VITE_ASSET__D1yDCfbI__"